module.exports = __webpack_public_path__ + "static/media/XUnitIcon.57346f4e.svg";